import React, { useEffect, useState } from "react";
import { Grid, FormControlLabel, Switch, Button } from "@material-ui/core";
import { WebcamCard } from "../components/home/WebcamCard";
import { WebcamCardMediapipe } from "../components/home/WebcamCardMediapipe";

import { HomeWrapper } from "../components/utils/HomeWrapper";
import { RecordingButtons } from "../components/home/RecordingButtons";
import { VideoTimer } from "../api/VideoTimer";
import { SignDialog } from "../components/dialog/SignDialog";
// import { postmanSendVideo, postmanSendFeedback } from "../api/Postman";
import { checkCameraPermissions, saveVideo } from "../api/utils/webcam";
import { useVideo } from "../api/VideoProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { formatAnonymous } from "../api/utils/strings";
import { CameraPermissionsPrompt } from "../components/home/CameraPermissionsPrompt";
import { pStatus, pDB_user_roles, pCustomFilter } from "../utils/parameters";
import { useSnackbar } from "notistack";
//import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
//import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import CropFreeIcon from '@mui/icons-material/CropFree';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { CustomWebcamOptions } from "../components/search/CustomFilters";
// import { Visibility, VisibilityOff, BlurOn, BlurOff } from '@material-ui/icons/';
import useMediaQuery from "@mui/material/useMediaQuery";
import "../styles/devices/mob_Home.css";
import { useDataProvider } from "../api/DataProvider";
import device from "current-device";
import Tooltip from '@mui/material/Tooltip';
import { useTour } from "@reactour/tour";
import { stepsSearchLSE } from "../components/tour/TourConfig";
import { useCommProvider } from "../api/CommProvider";
import { PageTitle } from '../components/utils/PageTitle';
import { useLocation } from "react-router-dom";

import { BlurOn, BlurOff } from '@material-ui/icons/';

import { WebcamSelection } from "../components/home/WebcamSelection";
import { ReminderComponent } from "../components/utils/ReminderComponent";
import { AvailableSignsTable } from "../components/search/AvailableSignsTable";

import { SubmissionBannerV2 } from "../components/search/SubmissionBanner_v2";
import { SubmissionBanner } from "../components/search/SubmissionBanner";
import { useTranslation } from "react-i18next";

import { Recorder } from "../components/stream/Recorder";


var lodash = require('lodash');
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useRef } from "react";
import { DeviceQueries } from "../components/utils/DeviceQueries";
import { useStreamProvider } from "../api/StreamProvider";
import { useMediapipeHolisticProvider } from "../api/MediapipeHolisticProvider";


export function Home2() {
  const { t } = useTranslation("global")

  const [dialogElements, setDialogElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token_id, currentUser, currentUserRole, genEntryByGloss, genEntryByLemma } = useDataProvider();
  const { comm_sendVideo, comm_sendMediapipe, comm_sendMediapipeFastMode, commm_updateFeedback } = useCommProvider();
  const [mediaBlobUrl, setMediaBlobUrl] = useState("");
  const [mediapipeData, setMediapipeData] = useState(null);
  const [openOptionsMenu, setOpenOptionsMenu] = useState(false);
  const [optionsMenuState, setOptionsMenuState] = useState([
      false,   // offset
      true,  // showFraming
      false,  // activateKeypoints
      false,  // autoControl
      false,  // virtualBG - activate / deactivate
  ]);
  const [blurSettings, setBlurSettings] = useState({
    'blur': 0,
    'image': false
  })


  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  /* Contexts */
  const { faceStatus, setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });

  const [switchGalibo, setSwitchGalibo] = useState(true);
  const [switchSide, setSwitchSide] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const [feedback, setFeedback] = useState([]);
  const [feedback_actual_vid, setFeedback_actual_vid] = useState("");

  const [prevDialogPosition, setPrevDialogPosition] = useState(undefined);
  const [reminderSnack, setReminderSnack] = useState({ open: false, text: "" });

  const [switchMediapipe, setSwitchMediapipe] = useState(false)
  const [switchVisualControl, setSwitchVisualControl] = useState(false)
  const [enableVisualControl, setEnableVisualControl] = useState(false)
  const [visualControlAction, setVisualControlAction] = useState('')

  const { streamMediaBlobUrl } = useStreamProvider();
  const { json_web_info } = useDataProvider();

  const { getMediapipeHolisticDataBuffer, clearMediapipeHolisticDataBuffer, startMediapipeHolisticDataBufferRecord, stopMediapipeHolisticDataBufferRecord } = useMediapipeHolisticProvider();

 
  const queryMatches = DeviceQueries();

  /* Set initial values every time the Home page is opened */
  (() => {
    setFaceStatus(pStatus.init);
  }, [setFaceStatus]);

  async function send2Server(){
    // console.log("🚀 ~ file: Home.js:195 ~ send2Server ~ mediaBlobUrl:", mediaBlobUrl)
    if (switchMediapipe === true){
        // console.log('send2ServerMediapipe()')
        send2ServerMediapipe()
        setSwitchMediapipe(false);
    }else{
        // console.log('send2ServerVideo()')
        send2ServerVideo()
    }
    setFaceStatus(pStatus.init)
  }

  async function send2ServerMediapipe(){
    console.log("🚀 ~ send2ServerMediapipe ~ send2ServerMediapipe:", send2ServerMediapipe)

    setOpenDialog(true);
    setLoading(true);

    var auxSign = []
    const uid = (currentUser.isAnonymous ? formatAnonymous(currentUser.uid) : currentUser.uid)


    try{

      // const videoFile = await saveVideo(streamMediaBlobUrl);
      const jsonData = JSON.stringify(getMediapipeHolisticDataBuffer());
      const blob = new Blob([jsonData], { type: 'application/json' });
      const fileData = new File([ blob ], 'data.json');

      const bloblurl = URL.createObjectURL(blob);
      console.log('OBTAINED VIDEOFILE & FILEDATA: ', bloblurl)


      auxSign = await comm_sendMediapipeFastMode(token_id, currentUser, fileData);
      // console.log('AUX SIGN: ', auxSign)
      if (auxSign['code'] === undefined){
        setFeedback_actual_vid(auxSign['_id'])
        const arr_signs = auxSign['arr_predictions']
        const arr_prob = auxSign['arr_probabilities']
        const { dialog_elements, position_gloss_uid } = genEntryByGloss(arr_signs, arr_prob);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ dialog_elements", dialog_elements);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ position_gloss_uid", position_gloss_uid);

        setDialogElements(dialog_elements);

        const initialPosition = {};
        Object.keys(position_gloss_uid).forEach((key) => {
          initialPosition[key] = position_gloss_uid[key][0];
        });
        setPrevDialogPosition(initialPosition);
        setLoading(false);
        
      }else{
        switch(auxSign['error']){
          case 'NO_MODEL':
            setSnack({ ...snack, open: true, text: "SERVIDOR PRINCIPAL CON PROBLEMAS. \n No es posible procesar los vídeos para obtener un resultado. \n Le pedimos disculpas.", type: "error" , autoHideDuration: 10000});
            break;
          case 'NO_BODY':
            setSnack({ ...snack, open: true, text: "CUERPO NO DETECTADO. \n No se ha detectado kps correspondientes al cuerpo.", type: "error" , autoHideDuration: 10000});
            break;
          case 'VIDEO_LQ':
            setSnack({ ...snack, open: true, text: "VÍDEO DE BAJA CALIDAD. \n El vídeo enviado no cumple con los requisitos de calidad mínimos.", type: "error" , autoHideDuration: 10000});
            break;
        }
        setFaceStatus(pStatus.init)
      }
    }catch(err){
      setOpenDialog(false);
      console.error(err)
      setSnack({ ...snack, open: true, text: t("sRecordComponent.serverError"), type: "error" });
    }
}


  /* Send video to server */
  async function send2ServerVideo() {
    /* 1: Dialog loading */
    setOpenDialog(true);
    setLoading(true);
    var auxSign = [];
    /* 2: Save video to file: saveVideo() */
    const videoFile = await saveVideo(streamMediaBlobUrl);
    // console.log("🚀 ~ file: Home.js:195 ~ send2ServerVideo ~ mediaBlobUrl:", mediaBlobUrl)
    /* 3: Get correspondent sign fro server */
    try{
      auxSign = await comm_sendVideo(token_id, currentUser, videoFile);

      // console.log('AUX SIGN: ', auxSign)

      if (auxSign['code'] === undefined){
        setFeedback_actual_vid(auxSign['_id'])
        const arr_signs = auxSign['arr_predictions']
        const arr_prob = auxSign['arr_probabilities']
        const { dialog_elements, position_gloss_uid } = genEntryByGloss(arr_signs, arr_prob);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ dialog_elements", dialog_elements);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ position_gloss_uid", position_gloss_uid);

        setDialogElements(dialog_elements);

        const initialPosition = {};
        Object.keys(position_gloss_uid).forEach((key) => {
          initialPosition[key] = position_gloss_uid[key][0];
        });

        setPrevDialogPosition(initialPosition);
        setLoading(false);
        
      }else{
        switch(auxSign['error']){
          case 'NO_MODEL':
            setSnack({ ...snack, open: true, text: "SERVIDOR PRINCIPAL CON PROBLEMAS. \n No es posible procesar los vídeos para obtener un resultado. \n Le pedimos disculpas.", type: "error" , autoHideDuration: 10000});
            break;
          case 'NO_BODY':
            setSnack({ ...snack, open: true, text: "CUERPO NO DETECTADO. \n No se ha detectado kps correspondientes al cuerpo.", type: "error" , autoHideDuration: 10000});
            break;
          case 'VIDEO_LQ':
            setSnack({ ...snack, open: true, text: "VÍDEO DE BAJA CALIDAD. \n El vídeo enviado no cumple con los requisitos de calidad mínimos.", type: "error" , autoHideDuration: 10000});
            break;
        }
        setFaceStatus(pStatus.init)
      }
    }catch(err){
      setOpenDialog(false);
      console.error(err)
      setSnack({ ...snack, open: true, text: t("sRecordComponent.serverError"), type: "error" });
    }
  }

  /* Send video to server */
  async function sendFeedback2Server(data, data_labels) {
    try{
      commm_updateFeedback(token_id, currentUser, feedback_actual_vid, data, data_labels);
      setSnack({ ...snack, open: true, text: "Enviado su reporte. Muchas gracias por colaborar.", type: "info" });
    }catch(e){
      setSnack({ ...snack, open: true, text: e, type: "error" });
    }
  }


  /* Check device & Camera permissions */
  useEffect(() => {
    /* Only check if there are no camera permissions */
    if (!cameraPermissions.cam) {
      /* Status and permissions prompt */
      setCameraPermissions({ ...cameraPermissions, perm: false });
      setFaceStatus(pStatus.error);
      /* Check permissions again */
      checkCameraPermissions()
        .then((r) => {
          setCameraPermissions({ ...cameraPermissions, perm: r, cam: r });
          r ? setFaceStatus(pStatus.init) : setFaceStatus(pStatus.error);
        })
        .catch((e) => setCameraPermissions({ ...cameraPermissions, perm: false, cam: false }));
    }
    // eslint-disable-next-line
  }, []);


  /* Tour */
  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }


  /*** Adding AvailableSignsTable to Home ***/
  /* Show dialog */
  async function showDialog(row_id) {
    const data_dialog_elements = genEntryByLemma(row_id)
    setDialogElements(genEntryByLemma(row_id));
  }

  useEffect(() => {
    if (Object.keys(dialogElements).length > 0) {
      setOpenDialog(true);
    }else{
      setOpenDialog(false);
    }
  }, [dialogElements]);


  return (
    <HomeWrapper>
      {json_web_info['server_status'] === 'DOWN' ? (
        <PageTitle title={t("sHub.search_in_LSE").toUpperCase()} error={t("sWebInfo.server_main_problems")}/>
      ):<></>
      }
      <Recorder action_send={send2ServerVideo}/>
      <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={loading} openDialog={openDialog} setOpenDialog={setOpenDialog} sendFeedback2Server={sendFeedback2Server} setFeedback={setFeedback} prevDialogPosition={prevDialogPosition} setPrevDialogPosition={setPrevDialogPosition} switchVisualControl={switchVisualControl} setVisualControlAction={setVisualControlAction} visualControlAction={visualControlAction} noCenterDialog={switchVisualControl}/>
      <HelpSnackbar snack={snack} setSnack={setSnack} />
    </HomeWrapper>
  );

}


